<template>
  <div class="index" :class="ism">
    <pc :class="ism" :ism="ism"></pc>
  </div>
</template>

<script>
import pc from "./pc.vue";
export default {
  name: "index",
  components: { pc },
  props: {
    ism: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
</style>
